import { ID } from "src/libs/interfaces/layouts";
import { actions } from "src/modules/pe-landing-module/data/actions";
import { UPDATE_EXTERNAL_LANDING_ACTION } from "src/modules/pe-landing-module/data/actionTypes";

export default function saveExtended(src: string, id: ID, land_id: ID, callBack?: () => void ) {
    actions( UPDATE_EXTERNAL_LANDING_ACTION, {
        id,
        land_id,
        input: {
            json: src
        }
    } )
    .then(( resp: any ) => {
        // console.log( resp )
        if(callBack) {
            callBack()
        }
    })
}